"use client";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { AdvantagesButtonLink } from "@/components/screen/global-components/advantages";
import { Typography } from "@/components/ui/typography";
import Icon from "@/components/ui/Icon";

type AdvantageLink = {
  label?: string;
  href: string;
};

const AdvantagesLink: AdvantageLink[] = [
  {
    label: "Education",
    href: "/use-cases/academic",
  },
  {
    label: "Finance",
    href: "/use-cases/financial",
  },
  {
    label: "Government",
    href: "/industries/government",
  },
  {
    label: "Healthcare",
    href: "/use-cases/medical",
  },
  {
    label: "Law",
    href: "/use-cases/legal",
  },
];

export default function AdvantagesBlock() {
  return (
    <section className="section bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:text-center">
          <Typography variant="heading4">
            <h2>
              Professional e-learning translation services for any industry
            </h2>
          </Typography>
          <div className="flex justify-center text-gray-600 w-full md:max-w-[786] md:mx-auto">
            <Typography variant="subHeadingSm" asChild>
              <p>
                Translators with industry expertise provide accurate,
                high-quality translations that are fast, reliable, and secure.
              </p>
            </Typography>
          </div>
        </div>
        <div className="mt-6 md:mt-12 grid grid-cols-2 gap-4 md:grid-cols-3">
          {AdvantagesLink.map(({ label, href }, i) => {
            return (
              <AdvantagesButtonLink key={i} href={href}>
                {label}
              </AdvantagesButtonLink>
            );
          })}
          <Button
            className="flex rounded-2xl !py-[19.2] !px-6 md:!py-4 bg-blue text-white text-lg leading-[130%] lg:font-semibold lg:text-lg lg:leading-[150%]  justify-between items-center gap-2 hover:bg-blue-600 transition-colors h-auto"
            asChild
          >
            <Link href="/industries">
              <span className="min-w-0 truncate">Explore industries</span>
              <Icon id="icon-arrow-right-lg_24"
                width={24}
                height={24}
                className="shrink-0 !w-6 !h-6"
              />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
